import React from 'react'
import {style} from 'util/style'

const styles = style('loadingicon')
import './LoadingIcon.scss'
type LoadingIconType = {}

export const LoadingIcon: React.FC<LoadingIconType> = (Attributes) => {
	return <div className={styles} />
}
